import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-searchbar',
  templateUrl: './searchbar.component.html',
  styles: []
})
export class SearchbarComponent implements OnInit {

  public Form: FormGroup;
  public errorMessage: string;

  constructor(private formBuilder: FormBuilder, private router: Router) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.Form = this.formBuilder.group({
      terms: ['', [Validators.nullValidator]]
    });
  }

  onSubmit() {
    const terms = this.Form.get('terms').value;
    this.Form.get('terms').setValue('');
    this.router.navigate(['/search/'], { queryParams: { query: terms }});
  }

}
